/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = [".container[_ngcontent-%COMP%] {\n  padding: 20px; }\n  .container[_ngcontent-%COMP%]   .i-xsml[_ngcontent-%COMP%] {\n    width: 20px;\n    height: 20px;\n    margin-right: 10px; }\n  .container[_ngcontent-%COMP%]   a.download-link[_ngcontent-%COMP%] {\n    display: inline-flex;\n    align-items: center;\n    padding: 15px;\n    background: #eee;\n    font-size: 18px;\n    color: #333333;\n    text-decoration: none;\n    margin-top: 20px; }\n  .container[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%] {\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 28px;\n    margin-bottom: 20px;\n    margin-top: 0;\n    color: #333; }\n  .container[_ngcontent-%COMP%]   .mod-e-hinweisbox[_ngcontent-%COMP%] {\n    border: 1px solid #aaa;\n    padding: 10px;\n    width: 100%;\n    height: auto; }\n  .container[_ngcontent-%COMP%]   label.invisible[_ngcontent-%COMP%] {\n    display: none; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-form/terms/terms.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 